var map = {
	"./1.png": "J4tQ",
	"./2.png": "+ZwS",
	"./3.png": "r/lx",
	"./FP_G.svg": "Rn3z",
	"./Layer0.png": "an4C",
	"./Layer1.png": "vyLR",
	"./Mock.png": "yya0",
	"./Post_1.png": "ZdIF",
	"./Posts.png": "9aqq",
	"./foodpage-banner.jpg": "Wg1w",
	"./wireframe.png": "4YAx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xc+a";